/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt } from '../twd'

export const LastTrade = ({context}) => {
    const {tradeDateTime, tradePrice, tradeYield, tradeQuantity, tradeType, isEstimate} = context.lastTrade

    return <React.Fragment>
        <div className="row">
        <h4 className="col-md-12 text-medium last-trade-heading">Last reported trade</h4>
        </div>

        <div className="row vertical-offset-sm last-trade-container">
        <div className="col-md-12">
            <dl className="last-trade-dl">
            <div>
                <dt>Trade Date</dt>
                <dd className="text-medium" style={{whiteSpace:'nowrap'}}>{fmt.ts(tradeDateTime)}</dd>
            </div>
            <div>
                <dt className="text-right">Price</dt>
                <dd className="text-right text-medium">{fmt.price3(tradePrice)}</dd>
            </div>
            <div>
                <dt className="text-right">Yield</dt>
                <dd className="text-right text-medium">{fmt.ytw3(context.hasTradeYield ? tradeYield : null)}</dd>
            </div>
            <div>
                <dt className="text-right">Quantity</dt>
                <dd className="text-right text-medium">{isEstimate ? '* 1,000' : fmt.qty(tradeQuantity)}</dd>
            </div>
            <div>
                <dt>Trade Type <span className="xs-hide">(Special Notes)</span></dt>
                <dd className="text-medium">{tradeType || fmt.empty()}</dd>
            </div>
            </dl>
        </div>    
        </div>        
    </React.Fragment>
}




// WEBPACK FOOTER //
// ./src/trade-history/last-trade.js